import type { AthenaAuthBindings, InternalAthenaAuthModule } from "../types.ts";

/**
 * Flat InternalAthenaAuthModule aliases. Canonical methods live on `auth`.
 * This module must not implement HTTP or session effects.
 */
export function attachAuthCompatibilityAliases(input: {
  auth: AthenaAuthBindings;
  baseUrl: string;
  request: InternalAthenaAuthModule["request"];
  resolveResetPasswordToken: InternalAthenaAuthModule["resolveResetPasswordToken"];
  revokeSession: InternalAthenaAuthModule["revokeSession"];
  revokeSessions: InternalAthenaAuthModule["revokeSessions"];
}): InternalAthenaAuthModule {
  const {
    auth,
    baseUrl,
    request,
    resolveResetPasswordToken,
    revokeSession,
    revokeSessions,
  } = input;

  return {
    auth,
    authorization: auth.authorization,
    baseUrl,
    changeEmail: auth.changeEmail,
    changePassword: auth.changePassword,
    clearOtherSessions: auth.revokeOtherSessions,
    clearSession: revokeSession,
    clearSessions: revokeSessions,
    deleteUser: auth.user.delete,
    deleteUserCallback: auth.deleteUser.callback,
    forgetPassword: auth.forgetPassword,
    getAccessToken: auth.getAccessToken,
    getSession: auth.getSession,
    getToken: auth.getToken,
    getUser: auth.getUser,
    linkSocial: auth.social.link,
    listAccounts: auth.account.list,
    listSessions: auth.session.list,
    logout: auth.signOut,
    organization: auth.organization,
    refreshToken: auth.refreshToken,
    request,
    requireSession: auth.requireSession,
    resetPassword: auth.resetPassword,
    resolveResetPasswordToken,
    revokeOtherSessions: auth.revokeOtherSessions,
    revokeSession,
    revokeSessions,
    sendVerificationEmail: auth.sendVerificationEmail,
    signIn: auth.signIn,
    signOut: auth.signOut,
    signUp: auth.signUp,
    tokenProvider: auth.tokenProvider,
    unlinkAccount: auth.unlinkAccount,
    updateUser: auth.updateUser,
    verifyEmail: auth.verifyEmail,
  };
}
